import modal from 'modules/app-core/modal'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { reduxForm } from 'redux-form'
import EmpTerminationForm from '../../components/EmployeeForm/components/EmpTerminationForm'

const mapDispatchToProps = (dispatch) => ({
  onCancel(e) {
    e.preventDefault()
    dispatch(modal.actions.hideModal())
  },

  onConfirm: () => {},
})

const mapStateToProps = (state, props) => {
  const userId = props?.empData?.id
  let person = state?.persons?.list[userId]
  if (!person) {
    person = state?.personSearch?.searchResponseList.find(
      (person) => person.id === userId
    )
  }

  return {
    isTestUser: person?.isTestUser ?? person?.IsTestUser ?? false,
  }
}

const composedEmpTerminationForm = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'Emp_Termination_Form',
    enableReinitialize: true,
  })
)
export default composedEmpTerminationForm(EmpTerminationForm)
